import { MobiDocument } from './MobiDocument';

export class NiveauScolaireDocument extends MobiDocument{
    private _id : string;
    private _rev : string;
    private id : number;
    private intitule : string;
    private typecursus : string;
    private obsolete : boolean;

    constructor(niveausco : any){
        super()
        this._id = niveausco._id;
        this._rev = niveausco._rev;
        this.id = niveausco.id;
        this.intitule = niveausco.intitule;
        this.typecursus = niveausco.typecursus;
        this.obsolete = niveausco.obsolete;
    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getIntitule(): string {
        return this.intitule;
    }

    public setIntitule(intitule: string): void {
        this.intitule = intitule;
    }

    public getTypecursus(): string {
        return this.typecursus;
    }

    public setTypecursus(typecursus: string): void {
        this.typecursus = typecursus;
    }

    public isObsolete(): boolean {
        return this.obsolete;
    }

    public setObsolete(obsolete: boolean): void {
        this.obsolete = obsolete;
    }

}